import React, { useEffect } from 'react';
import { MessageCircle, Send } from 'lucide-react';

const FloatingButtons = () => {
  useEffect(() => {
    // Load Tawk.to script
    var Tawk_API = Tawk_API || {};
    var Tawk_LoadStart = new Date();

    (function() {
      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6971ed23e1a935198030fa98/1jfigcl55';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');

      // Only load if not already loaded
      if (!document.getElementById('tawkto-script')) {
        s1.id = 'tawkto-script';
        s0.parentNode.insertBefore(s1, s0);
      }
    })();

    return () => {
      // Cleanup if needed
      const script = document.getElementById('tawkto-script');
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="fixed right-6 bottom-24 z-[9998] flex flex-col gap-4" role="group" aria-label="Quick contact options">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/918982892301?text=Hello%20Equi%20Pulse!%20I'd%20like%20to%20know%20more%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full shadow-2xl shadow-green-900/50 hover:shadow-green-700/70 transition-all duration-300 hover:scale-110"
        aria-label="Chat with us on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" aria-hidden="true" />
        <span className="absolute right-16 px-3 py-1.5 bg-slate-800 text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity duration-200 whitespace-nowrap shadow-lg pointer-events-none" aria-hidden="true">
          Chat on WhatsApp
        </span>
      </a>

      {/* Telegram Button */}
      <a
        href="https://t.me/equipulse"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-full shadow-2xl shadow-blue-900/50 hover:shadow-blue-700/70 transition-all duration-300 hover:scale-110"
        aria-label="Join our Telegram channel"
      >
        <Send className="w-7 h-7 text-white" aria-hidden="true" />
        <span className="absolute right-16 px-3 py-1.5 bg-slate-800 text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity duration-200 whitespace-nowrap shadow-lg pointer-events-none" aria-hidden="true">
          Join Telegram
        </span>
      </a>

      {/* Tawk.to chat widget will appear automatically below these buttons */}
    </div>
  );
};

export default FloatingButtons;
